import React from 'react';
import Util from '../../../../shared/util/util';
import {useIntl} from 'react-intl';

const FormattedMinutes = ({value}) => {
	const intl = useIntl();
	return Util.isNumber(value) ? Util.convertMinutesToFullHour(value, intl) : '-';
};

const FormattedPoints = ({value}) => {
	const intl = useIntl();
	return Util.isNumber(value) ? `${intl.formatNumber(value, {format: 'always_two_decimal'})}p` : '-';
};

const FormattedCurrency = ({value, currency}) => {
	const intl = useIntl();
	return Util.isNumber(value)
		? Util.GetFormattedCurrencySymbol(currency, intl.formatNumber(value, {format: 'always_two_decimal'}))
		: '-';
};

export const TaskTotalsHeaders = {
	EstimateHours: ({totals}) => <FormattedMinutes value={totals?.work?.estimate?.minutes} />,
	EstimatePoints: ({totals}) => <FormattedPoints value={totals?.work?.estimate?.points} />,
	RemainingHours: ({totals}) => <FormattedMinutes value={totals?.work?.remaining?.minutes} />,
	RemainingPoints: ({totals}) => <FormattedPoints value={totals?.work?.remaining?.points} />,
	DifferenceHours: ({totals}) => {
		const difference = (totals?.work?.estimate?.minutes ?? NaN) - (totals?.reported?.time ?? NaN); // Avoids nulls being coerced to zero.
		return <FormattedMinutes value={difference} />;
	},
	DifferencePoints: ({totals}) => {
		const difference = (totals?.work?.estimate?.points ?? NaN) - (totals?.reported?.points ?? NaN); // Avoids nulls being coerced to zero.
		return <FormattedPoints value={difference} />;
	},
	ReportedHours: ({totals}) => <FormattedMinutes value={totals?.reported?.time} />,
	ProjectedHours: ({totals}) => <FormattedMinutes value={totals?.reported?.projected} />,
	PlannedRevenue: ({totals, currency}) => (
		<FormattedCurrency value={totals?.financial?.revenue?.planned} currency={currency} />
	),
	ActualRevenue: ({totals, currency}) => <FormattedCurrency value={totals?.financial?.revenue?.actual} currency={currency} />,
};
